module.exports = __webpack_public_path__ + "img/cityLogo.987cece3.png";